export default "2342b78946ef246a29329fac319fdca7.svg";